import CategoryWorkshopsBlock from './CategoryWorkshopsBlock';

export default CategoryWorkshopsBlock;
